import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import styled from "styled-components";
import MUISwitch, { SwitchProps } from "@mui/material/Switch";

interface LabelsInterface {
    labels: {
        yes: string;
        no: string;
    };
}

const StyledSwitch = styled(MUISwitch)<LabelsInterface>`
    width: 60px;
    height: 24px;
    border-radius: 30.5px;
    padding: 0;

    .input {
        left: 0;
        height: 24px;
        top: -2px;
    }

    .switchBase {
        padding: 0;
        margin: 2px;
    }

    .checked {
        transform: translateX(36px);
        color: var(--color-white);

        .input {
            left: -38px;
        }

        & + .track {
            background-color: var(--color-secondary);
            opacity: 1;

            &::after {
                color: white;
                left: calc(50% - 18px);
                content: "${(props) => props.labels.yes}";
            }
            &::before {
                content: "";
            }
        }
    }

    .track {
        opacity: 1;
        background-color: #e8ebeb;

        &::after,
        &::before {
            font-size: var(--size-10);
            position: absolute;
            top: 4px;
        }

        &::before {
            color: #939393;
            right: calc(50% - 18px);
            content: "${(props) => props.labels.no}";
        }
    }

    .disabled {
        color: #e8ebeb;
        border: 1px solid #d2d7d7;
        & + .track {
            background-color: #e8ebeb;

            &::after,
            &::before {
                color: #939393;
            }
        }
    }
`;

const classes = { switchBase: "switchBase", input: "input", checked: "checked", track: "track", disabled: "disabled" };

const Switch: FC<SwitchProps> = ({ ...rest }) => {
    const { t } = useTranslation();

    const labels = {
        yes: t("Common.Yes"),
        no: t("Common.No"),
    };

    return <StyledSwitch classes={classes} labels={labels} {...rest} />;
};

export default Switch;
